namespace Dashboard {

    export class MybTrack {
        constructor(
            private analytics,
            private currentUser
            ) { }

        public track(event, props) {
            if (props == null) {
                props = {};
            }
            props.SignIn = !!this.currentUser.get().HardSignedIn;
            this.analytics.track('mixpanel', event, props);
        }
    }

    angular
        .module('dashboard')
        .service('mybTrack', MybTrack);

}
